import type { IconSvgObject } from './types';

const CurvyLeftRightDirectionIcon: IconSvgObject = [
  ["path", { d: "M2 11L6.00006 11C7.10463 11 8.00006 11.8954 8.00006 13V17C8.00006 18.1046 8.8955 19 10.0001 19C11.1046 19 12.0001 18.1046 12.0001 17V6.99583C12.0001 5.89356 12.8936 5 13.9959 5C15.1014 5 15.9963 5.89865 15.9917 7.00415L15.9751 10.9916C15.9704 12.0995 16.8672 13 17.975 13L22 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 15L22 13L20 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 9L2 11L4 13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CurvyLeftRightDirectionIcon;
